import React from 'react';
import { Admin, Resource, ListGuesser, ShowGuesser, CustomRoutes } from 'react-admin';
import { dataProvider } from './dataProvider';
import { authProvider } from './authProvider';
import { Route } from 'react-router-dom';

//Pages
import { UserList, UserEdit, UserCreate, UserShow } from './Pages/Users';
import { SupportList } from './Pages/Supports';
import { LogsList, LogsShow } from './Pages/Logs';
import Dashboard from './Dashboard';
import { OculusMain } from './Pages/Oculus';
import { AiUsageList, AiUsageShow } from './Pages/AI';
import { ChatAdmin, ChatRoom } from './Pages/Chats';

import {
    MessagesShow,
    MessagesCreate,
    MessagesEdit,
    MessageReadsShow
} from './Pages/Messages';

import MessagesManager from './Pages/Messages';
import { tempProyectosResource } from './Pages/TempProyects';

import {
    VersionList,
    VersionCreate,
    VersionEdit,
    VersionShow
} from './Pages/Version';

//Icons
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import PeopleIcon from '@mui/icons-material/People';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import HubIcon from '@mui/icons-material/Hub';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ForumIcon from '@mui/icons-material/Forum';

import NotFound from './Pages/NotFound.js';

const AuthenticationError = () => (
    <div>
        <h1>Authentication error</h1>
        <p>You don't have access to this page.</p>
    </div>
);

const App = () => (
    <Admin
        requireAuth
        catchAll={NotFound}
        authenticationError={AuthenticationError}
        authProvider={authProvider}
        dataProvider={dataProvider}
        dashboard={Dashboard}
    >
        <Resource name="users" icon={PeopleIcon}
            list={UserList}
            show={UserShow}
            edit={UserEdit}
            create={UserCreate}
        />
        <Resource name="aiusage" icon={AutoAwesomeIcon}
            options={{ label: 'AI Usage' }}
            list={AiUsageList}
            show={AiUsageShow}
        />
        <Resource name="oculus" icon={LoyaltyIcon}
            options={{ label: 'Oculus Subscriptions' }}
            list={OculusMain}
        />
        <Resource name="available_purchases" />
        <Resource name="messages"
            list={MessagesManager}
            show={MessagesShow}
            create={MessagesCreate}
            edit={MessagesEdit}
        />
        <Resource name="messages_reads" show={MessageReadsShow} />
        <Resource {...tempProyectosResource} />
        <Resource name="Feedback" icon={ChatBubbleIcon}
            list={ListGuesser}
            show={ShowGuesser}
        />
        <CustomRoutes>
            <Route path="/chats"         element={<ChatAdmin />} />
            <Route path="/chats/:chatId" element={<ChatRoom />} />
        </CustomRoutes>
        <Resource
            name="chats"
            list={ChatAdmin}
            icon={ForumIcon}
            options={{ label: 'Support Chats' }}
        />
        <Resource name="supports" icon={ContactSupportIcon}
            list={SupportList}
        />
        <Resource name="version" icon={AdsClickIcon}
            list={VersionList}
            create={VersionCreate}
            edit={VersionEdit}
            show={VersionShow}
            options={{ label: 'Versiones de App' }}
        />
        <Resource name="logs" icon={HubIcon}
            list={LogsList}
            show={LogsShow}
        />
    </Admin>
);

export default App;